export default "__VITE_ASSET__DOMoqVqx__"